export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string' || string.length === 0) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.error('Error al copiar al portapapeles:', error);
  }
};

export const PHONE_NUMBER_LENGTH = 10;

const getPhonePrefixLength = (value) => {
  if (value.startsWith('015')) return 3;
  if (value.startsWith('15')) return 2;
  if (value.startsWith('0')) return 1;
  return 0;
};

export const stripPhonePrefix = (value) => {
  if (typeof value !== 'string') {
    return value;
  }
  return value.slice(getPhonePrefixLength(value));
};

// Elimina primero el prefijo (0, 15 o 015) y, si el resto sigue teniendo más de
// PHONE_NUMBER_LENGTH dígitos, recorta el excedente del final (no del principio).
// También reubica el cursor para que no salte al final del input al pegar/borrar.
export const transformPhoneInput = (rawValue, cursorPos = 0) => {
  if (typeof rawValue !== 'string') {
    return { value: rawValue, cursor: cursorPos };
  }
  const prefixLength = getPhonePrefixLength(rawValue);
  const stripped = rawValue.slice(prefixLength);
  const value = stripped.length > PHONE_NUMBER_LENGTH ? stripped.slice(0, PHONE_NUMBER_LENGTH) : stripped;
  const cursor = Math.min(Math.max(0, cursorPos - prefixLength), value.length);
  return { value, cursor };
};

export const extractInputValue = (eventOrValue) => {
  if (eventOrValue && typeof eventOrValue === 'object' && 'target' in eventOrValue) {
    return eventOrValue.target.value;
  }
  return eventOrValue;
};

const isBlockedInsertion = (currentValue, rawValue) => {
  return currentValue.length >= PHONE_NUMBER_LENGTH && rawValue.length - currentValue.length === 1;
};

export const createPhoneChangeHandler = (fieldOnChange, currentValue = '') => (eventOrValue) => {
  const rawValue = extractInputValue(eventOrValue);
  const target = eventOrValue && eventOrValue.target;

  if (target && isBlockedInsertion(currentValue, rawValue)) {
    const rawCursor = typeof target.selectionStart === 'number' ? target.selectionStart : rawValue.length;
    const cursor = Math.min(Math.max(0, rawCursor - 1), currentValue.length);

    fieldOnChange(currentValue);

    setTimeout(() => {
      if (document.activeElement === target) {
        target.value = currentValue;
        target.setSelectionRange(cursor, cursor);
      }
    }, 0);
    return;
  }

  const rawCursor = target && typeof target.selectionStart === 'number' ? target.selectionStart : rawValue.length;
  const { value, cursor } = transformPhoneInput(rawValue, rawCursor);

  fieldOnChange(value);

  if (target) {
    setTimeout(() => {
      if (document.activeElement === target) {
        target.setSelectionRange(cursor, cursor);
      }
    }, 0);
  }
};